import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  theme: any;
}

export const Wrapper = styled.div<IProps>`
  padding: ${rem(14)} ${rem(18)} ${rem(12)};
  display: flex;
  align-items: center;
  ${({ theme }) => theme.media.fold`
    padding: ${rem(14)} ${rem(20)}  ${rem(12)};
  `}
`;

export const Select = styled.select<IProps>`
  display: inline-block;
  background-color: transparent;
  color: ${({ theme }) => theme.color['gray-600']};
  appearance: none;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  outline: none;
  border: none;
  margin-right: ${rem(8)};
  font-size: ${rem(12)};
  ${({ theme }) => theme.media.fold`
    font-size: ${rem(10)};
  `};
`;
